import React from "react";
import {
  Container,
  Col,
  Row,
  Card,
  CardHeader,
  CardTitle,
  CardBody
} from "reactstrap";

import bgImage1 from "assets/img/minibg/bg1.jpg";
import bgImage2 from "assets/img/minibg/bg2.jpg";
import bgImage3 from "assets/img/minibg/bg3.jpg";
import bgImage4 from "assets/img/minibg/bg4.jpg";
import bgImage5 from "assets/img/minibg/bg5.jpg";
import bgImage6 from "assets/img/minibg/bg6.jpg";
import bgImage7 from "assets/img/minibg/bg7.jpg";
import bgImage8 from "assets/img/minibg/bg8.jpg";
import bgImage9 from "assets/img/minibg/bg9.jpg";
import bgImage10 from "assets/img/minibg/bg10.jpg";
import bgImage11 from "assets/img/minibg/bg11.jpg";
import bgImage12 from "assets/img/minibg/bg12.jpg";
import nowLogo from "assets/img/nadu-logo-full.png";
import axios from "axios";

// const API = "https://mi.nadunet.es/api/rest/";
const DEBUG_MODE = window.location.host.includes("localhost");
const API = DEBUG_MODE
  ? "https://mi.nadunet.es/api/rest/"
  : "https://" + window.location.host + "/api/rest/";
const GET_URL = "nadunet_office_resources/get_url_from_alias";
const bgs = [
  bgImage1,
  bgImage2,
  bgImage3,
  bgImage4,
  bgImage5,
  bgImage6,
  bgImage7,
  bgImage8,
  bgImage9,
  bgImage10,
  bgImage11,
  bgImage12
];
class LoginPage extends React.Component {
  constructor(props) {
    super(props);

    let url_alias = window.location.pathname.substring(1);
    let randomBgNumber = this.randomIntFromInterval(0, 11);
    let randomBg = bgs[randomBgNumber];

    this.state = {
      randomBg: randomBg,
      url_alias: url_alias.length > 0 ? url_alias : false,
      changeMessage: null
    };
    this.redirectTo = this.redirectTo.bind(this);
  }
  componentDidMount() {
    let url_alias = this.state.url_alias;
    if (url_alias) this.getURL(url_alias);
  }
  randomIntFromInterval(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }
  redirectTo(redirect) {
    // this.props.history.push(redirect);
    window.location.replace(redirect);
  }
  getURL(url_alias) {
    let request = {
      alias: url_alias
    };

    axios.post(API + GET_URL, request, {withCredentials: false})
      .then(result => {
        /* ////// console.log("################## RESPUESTA ################");
        ////// console.log(result); */
        let response = result.data;
        if (response.result === "OK") {
          this.redirectTo(response.url);
        } else {
          console.log("Ocurrió un error al obtener la URL: ", response.error);
          if (response.error === "RETRY") {
            this.getURL(url_alias);
          } else {
            this.setState({ changeMessage: "Ocurrió un error :(" });
          }
          // this.showError(response.error);
        }
      })
      .catch((error) => {
        this.getURL(url_alias);
      });
  }
  render() {
    return (
      <div>
        <div className="full-page-content">
          <div className="login-page">
            <Container>
              <Row>
                <Col
                  xs={12}
                  // md={8}
                  // lg={4}
                  className="ml-auto mr-auto text-center"
                  style={{
                    fontSize: "4em",
                    color: "#FFF"
                  }}
                >
                  <Card className="card-login card-plain">
                    <CardHeader>
                      <div className="logo-container">
                        <img src={nowLogo} alt="nadunet" />
                      </div>
                    </CardHeader>
                    <CardBody>
                      {this.state.url_alias ? (
                        this.state.changeMessage ?
                          this.state.changeMessage :
                          <span>
                            <i className="now-ui-icons arrows-1_refresh-69 spin" />{" "}
                            Cargando enlace
                          </span>
                        ) : (
                        "hola :)"
                      )}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
        <div
          className="full-page-background"
          style={{ backgroundImage: "url(" + this.state.randomBg + ")" }}
        />
      </div>
    );
  }
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/views/Pages/LoginPage.jsx